export default __webpack_public_path__ + "static/Graphik-SemiboldItalic-Web-e0630121c173ef2eb971f030e9a1b8a5.woff";